import { Dispatch, useReducer } from 'react';

import { translate } from '~l10n/client';

import { assertUnreachable } from '../../../../util/assertUnreachable';

interface DuplicateWorkspaceQuizDialogState {
  open: boolean;
  initialQuizName: string;
  workspaceQuizId: string;
  workspaceId: string;
}

const initialState: DuplicateWorkspaceQuizDialogState = {
  open: false,
  initialQuizName: '',
  workspaceQuizId: null,
  workspaceId: null,
};
type DuplicateWorkspaceQuizDialogAction =
  | { type: 'close' }
  | {
      type: 'open';
      payload: {
        initialQuizName: string;
        workspaceQuizId: string;
        workspaceId: string;
      };
    };

function duplicateWorkspaceQuizDialogReducer(
  state: DuplicateWorkspaceQuizDialogState,
  action: DuplicateWorkspaceQuizDialogAction
): DuplicateWorkspaceQuizDialogState {
  switch (action.type) {
    case 'open': {
      const { workspaceId, workspaceQuizId, initialQuizName } = action.payload;
      return {
        workspaceId: workspaceId,
        workspaceQuizId: workspaceQuizId,
        initialQuizName: `${initialQuizName} (${translate('Copy')})`,
        open: true,
      };
    }
    case 'close': {
      return {
        workspaceId: null,
        workspaceQuizId: null,
        initialQuizName: '',
        open: false,
      };
    }
    default: {
      assertUnreachable(action);
    }
  }
}

export type DispatchDuplicateWorkspaceQuizDialogAction =
  Dispatch<DuplicateWorkspaceQuizDialogAction>;

export function useDuplicateWorkspaceQuizDialog(): [
  DuplicateWorkspaceQuizDialogState,
  DispatchDuplicateWorkspaceQuizDialogAction
] {
  return useReducer(duplicateWorkspaceQuizDialogReducer, initialState);
}
